module.exports = __webpack_public_path__ + "static/media/taegeuk.3ae99e6a.png";